/**
 * Customer dashboard layout spacing — single source of truth for Layout shell spacing.
 * Mirrors businessLayoutSpec / adminLayoutSpec rhythm (mt-12 / mb-12 / mb-8).
 */

import { POPUP_FORM_CONTENT_WIDTH_CLASS } from '../../../components/popup/popupLayoutSpec';

/** Margin below Header before page content. */
export const CUSTOMER_MAIN_HEADER_OFFSET_CLASS = 'mt-12';

function joinCustomerLayoutClasses(base, extraClasses = '') {
  const extra = (extraClasses || '').trim();
  return extra ? `${base} ${extra}` : base;
}

export function customerMainHeaderOffsetClass(extraClasses = '') {
  return joinCustomerLayoutClasses(CUSTOMER_MAIN_HEADER_OFFSET_CLASS, extraClasses);
}

export const CUSTOMER_PAGE_TITLE_OFFSET_CLASS = 'mb-12';

export function customerPageTitleOffsetClass(extraClasses = '') {
  return joinCustomerLayoutClasses(CUSTOMER_PAGE_TITLE_OFFSET_CLASS, extraClasses);
}

export const CUSTOMER_PAGE_TITLE_CLASS = CUSTOMER_PAGE_TITLE_OFFSET_CLASS;

export const CUSTOMER_CENTERED_PAGE_TITLE_CLASS =
  customerPageTitleOffsetClass('text-center pb-0');

export const CUSTOMER_LIST_PAGE_TITLE_CLASS =
  customerPageTitleOffsetClass('text-offblack pb-0');

export const CUSTOMER_TOOLBAR_OFFSET_CLASS = 'mb-8';

export function customerToolbarOffsetClass(extraClasses = '') {
  return joinCustomerLayoutClasses(CUSTOMER_TOOLBAR_OFFSET_CLASS, extraClasses);
}

export const CUSTOMER_TOOLBAR_CLASS = customerToolbarOffsetClass('px-4');

export const CUSTOMER_TABLE_OFFSET_CLASS = 'mb-12';

export function customerTableOffsetClass(extraClasses = '') {
  return joinCustomerLayoutClasses(CUSTOMER_TABLE_OFFSET_CLASS, extraClasses);
}

export const CUSTOMER_TABLE_CLASS = customerTableOffsetClass('!bg-white lg:px-4 w-full');

export const CUSTOMER_FORM_FOOTER_OFFSET_CLASS = 'mb-12';

export function customerFormFooterOffsetClass(extraClasses = '') {
  return joinCustomerLayoutClasses(CUSTOMER_FORM_FOOTER_OFFSET_CLASS, extraClasses);
}

export const CUSTOMER_FORM_FOOTER_CLASS = customerFormFooterOffsetClass('mt-12 px-4');

export const CUSTOMER_FORM_ACTION_ROW_CLASS = 'mt-12';

export const CUSTOMER_FORM_ACTION_ROW_END_CLASS =
  'flex items-center justify-end mt-12 w-full';

export const CUSTOMER_FORM_ACTION_ROW_BETWEEN_CLASS =
  'flex items-center justify-between mt-12 w-full';

export const CUSTOMER_FORM_SECTION_GAP_CLASS = 'mt-12';

export const CUSTOMER_SECTION_OFFSET_CLASS = 'mb-12';

export function customerSectionOffsetClass(extraClasses = '') {
  return joinCustomerLayoutClasses(CUSTOMER_SECTION_OFFSET_CLASS, extraClasses);
}

export const CUSTOMER_SECTION_CLASS = customerSectionOffsetClass();

export const CUSTOMER_FORM_PANEL_CLASS = '!bg-white lg:px-4 w-full';

export const CUSTOMER_CONTENT_PANEL_CLASS =
  '!bg-white w-full flex flex-col rounded-xl';

export const CUSTOMER_DETAIL_MAIN_HEADER_OFFSET_CLASS = 'mb-4';

export function customerDetailMainHeaderOffsetClass(extraClasses = '') {
  return joinCustomerLayoutClasses(CUSTOMER_DETAIL_MAIN_HEADER_OFFSET_CLASS, extraClasses);
}

export const CUSTOMER_DETAIL_MAIN_HEADER_CLASS =
  customerDetailMainHeaderOffsetClass('!bg-white');

export const CUSTOMER_POST_GRID_CLASS =
  'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mx-auto px-4';

export const CUSTOMER_LIST_FOOTER_CLASS = 'flex justify-center mt-12';

export const CUSTOMER_INBOX_CONTENT_CLASS = 'mx-auto w-full max-w-[1200px]';

export const CUSTOMER_WIZARD_SHELL_CLASS =
  'lg:px-5 lg:pb-10 relative !bg-white min-h-[calc(100vh-260px)] flex items-center';

export const CUSTOMER_WIZARD_CONTENT_CLASS =
  `${POPUP_FORM_CONTENT_WIDTH_CLASS} mx-auto`;

export const CUSTOMER_WIZARD_CONTENT_WIDE_CLASS =
  `${POPUP_FORM_CONTENT_WIDTH_CLASS} mx-auto`;

export const CUSTOMER_WIZARD_TITLE_CLASS =
  customerPageTitleOffsetClass('text-center pb-0 text-offblack');

/** Inbox thread panel height — header + layout offset. */
export const CUSTOMER_INBOX_THREAD_HEIGHT_CLASS = 'h-[calc(100vh-160px)]';

/** Vertically centered flows — skip layout header offset. */
export function isCustomerCenteredContentPath(pathname = '') {
  return pathname.includes('/customer-dashboard/tickets/create');
}
